import { DefaultService } from '@/services/DefaultService';

export default class LoteService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(lote) {
        return this._http.post(`${this._env}/vendas/lote`, lote, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAll(page = 0, limit = 50, order = 'asc', sort = 'descricao', situacao = 4, ...param) {
        return this._http.get(encodeURI(`${this._env}/vendas/lote/list.json?page=${page}&limit=${limit}&order=${order}&sort=${sort}&situacao=${situacao}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    find(id) {
        return this._http.get(`${this._env}/vendas/lote/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAllCombo(situacao = 1, ...param) {
        return this._http.get(encodeURI(`${this._env}/vendas/lote/getcombo.json?param=${param}&?situacao=${situacao}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    updateSituacao(lote) {
        return this._http.post(`${this._env}/vendas/lote/updatesituacao`, lote, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}